module.exports = __webpack_public_path__ + "img/test_r4.083b758a.png";